import { Injectable } from "@angular/core";
import { ServiciosRiegosService } from "../../../services/riesgo-liquidez/servicios-riegos.service";
import moment from "moment";
import { operaciones } from "./operaciones";
import { TemplateLoaderService } from "../../../shared/GenerateTabla/plantillas/template-loader.service";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class consultaInformatioService{

  constructor(
    private readonly service: ServiciosRiegosService,
    private readonly templateLoader: TemplateLoaderService,
  ){}

  async revisionCalculo(idEvaluacion, idInstitucion, per){
    const peri = moment(per, 'MMM YY');
    const val = await this.getRiesgos(
      idInstitucion,
      peri.month()+1,
      peri.year()
    );

    if(val.length === 0){
      await this.getAlerta(idEvaluacion, idInstitucion, peri.year(), peri.month()+1);
    }
  }

  private async getAlerta(idEvaluacion, idInstitucion, anio, mes){
    const val = await this.service.getDetalleCuentas(idEvaluacion);
    const configuracion = this.templateLoader.obtenerConfiguracionGap(idInstitucion);
    const bandas = configuracion.columnas.slice(1, configuracion.columnas.length-1);
    operaciones.forEach( async o =>{
      const dat = o.data.map( c => val.find(e=> e.idCuenta == c)?.valor ?? 0);
      const valor = dat.reduce( ( acc, v) => acc+=v,0);
      const bandasVal = bandas.map((e, index) => {
        var valorB = 0;
        if(o.bandas.includes(index)){
          valorB = valor*(1/o.bandas.length)
        }
        return {
          label: e,
          valor: valorB,
          order: index+1,
        }
      });
      const variable = {
        idInstitucion: idInstitucion,
        anio: Number(anio),
        mes: Number(mes),
        nombre: o.name
      }
      await firstValueFrom(this.service.postVariblesGapRiesgos(variable, bandasVal))
      
    })
  }

  private async getRiesgos(idInstitucion: string, mes: number, an: number){
    try{
      const response = await this.service.getGAPRiesgos(idInstitucion, mes, an);
      return response;
    }catch(err){
      if (this.esErrorDeConexion(err)) {
        // this.recargarTablero();
        return;
      }

      console.error(err);
    }
  }

  private esErrorDeConexion(error: any): boolean {
    const mensaje = error?.message ?? '';

    return (
      mensaje.includes('ERR_CONNECTION_TIMED_OUT') ||
      mensaje.includes('Failed to fetch') ||
      mensaje.includes('NetworkError')
    );
  }
}